/* The Virtue of God — Art Advisor (guided quiz + try-on-your-wall preview).
   Catalog: window.VOG_ADVISOR_CATALOG (assets/vog-advisor-data.js, generated from the store).
   Everything runs in the browser; wall photos never leave the visitor's device. */
(function () {
  'use strict';

  var STEPS = [
    { id: 'room', q: 'Which room is the artwork for?', hint: 'We use this to suggest the right scale and mood.', opts: [
      ['living', 'Living room', 'Gathering, sofa walls, fireplaces'], ['bedroom', 'Bedroom', 'Above the bed or a quiet corner'],
      ['dining', 'Dining / kitchen', 'Meals, coffee, open-plan spaces'], ['entry', 'Entry / hallway', 'First impressions, consoles, stairs'],
      ['office', 'Home office', 'Focus, calm, video-call backdrops'], ['bath', 'Bath / spa', 'Fresh, restful, a little luxurious']] },
    { id: 'feel', q: 'How should the room feel?', hint: 'Pick the one that sounds most like home.', opts: [
      ['calm', 'Calm & peaceful', 'Soft light, slow breathing'], ['warm', 'Warm & welcoming', 'Golden tones, open arms'],
      ['bright', 'Bright & joyful', 'Morning light, fresh colour'], ['romantic', 'Romantic & tender', 'Petals, blush, softness'],
      ['bold', 'Bold & vivid', 'Saturated colour, a statement'], ['reflective', 'Quiet & reflective', 'Moody skies, still water']] },
    { id: 'season', q: 'Which season speaks to you?', hint: 'Every collection follows the year outdoors.', opts: [
      ['spring', 'Spring', 'Blossoms and new beginnings'], ['summer', 'Summer', 'Long days, lakes and full bloom'],
      ['autumn', 'Autumn', 'Leaves, rain and amber light'], ['winter', 'Winter', 'Frost, snow and stillness'],
      ['any', 'All seasons', 'Show me the best of the year']] },
    { id: 'motif', q: 'What would you love to look at every day?', hint: 'Choose the subject you are drawn to.', opts: [
      ['flowers', 'Flowers & blossoms', 'Roses, lilies, magnolias, irises'], ['rain', 'Raindrops & dew', 'Petals and leaves after the rain'],
      ['mountains', 'Mountains & water', 'Peaks, lakes, sunsets'], ['leaves', 'Leaves & branches', 'Foliage, trees, forest light'],
      ['snow', 'Snow & frost', 'Ice crystals and winter trees'], ['any', 'Surprise me', 'Open to anything beautiful']] },
    { id: 'palette', q: 'Which colours suit your room?', hint: 'Think of your walls, textiles and wood tones.', opts: [
      ['neutral', 'Soft neutrals', 'Whites, creams, stone'], ['cool', 'Cool & airy', 'Blues, greens, silver'],
      ['warm', 'Warm & earthy', 'Gold, rust, blush, wood'], ['dark', 'Dark & moody', 'Deep tones, dramatic contrast'],
      ['colorful', 'Rich colour', 'Vivid, saturated, joyful'], ['any', 'Open to ideas', 'Let the photograph lead']] },
    { id: 'place', q: 'Where will it hang?', hint: 'Placement decides the shape that fits best.', opts: [
      ['sofa', 'Above a sofa', 'Or a long bench'], ['bed', 'Above a bed', 'Headboard wall'],
      ['console', 'Above a console or mantel', 'Sideboard, dresser, fireplace'], ['narrow', 'A narrow wall', 'Between windows, beside a door'],
      ['feature', 'A large open wall', 'A statement feature wall'], ['unsure', 'Not sure yet', 'Give me flexible options']] },
    { id: 'width', q: 'How wide is the furniture or wall space?', hint: 'For furniture, measure the piece. For an open wall, measure the space you want to fill.', width: true },
    { id: 'pieces', q: 'One photograph or a set?', hint: 'Sets of 2, 3 or 4 create a gallery look.', opts: [
      ['single', 'One photograph', 'A single focal point'], ['set', 'A set', 'A matching group of prints'],
      ['any', 'Either is fine', 'Show me both']] },
    { id: 'format', q: 'How would you like it to arrive?', hint: 'All three formats use Martha’s original photographs.', opts: [
      ['flat', 'Flat canvas print', 'Printed in Martha’s studio, ready for your own frame'], ['wrap', 'Gallery-wrapped canvas', 'Printed on demand, ready to hang'],
      ['frame', 'Black framed canvas', 'Printed on demand, ready to hang'], ['any', 'Not sure', 'Recommend what fits best']] }
  ];

  var WIDTHS = [[36, '36″', 'Small console'], [48, '48″', 'Dresser / bench'], [60, '60″', 'Queen bed'], [72, '72″', 'Sofa / king bed'], [96, '96″', 'Large sofa'], [120, '120″', 'Open wall']];
  var DEFAULT_W = { sofa: 84, bed: 64, console: 48, narrow: 30, feature: 120, unsure: 60 };
  var FURNITURE = { sofa: 1, bed: 1, console: 1 };

  var PERSONA = {
    calm: ['The Quiet Garden', 'You are looking for a wall that slows the breath — soft light, gentle colour and room to rest your eyes.'],
    warm: ['The Golden Hour Home', 'You want the feeling of late-afternoon sun: amber tones and a welcome that wraps around everyone who walks in.'],
    bright: ['The Morning Light', 'You love fresh, luminous colour — the kind of photograph that makes an ordinary morning feel new.'],
    romantic: ['The Rose Garden', 'Petals, blush and tender detail — art that feels like a handwritten note on the wall.'],
    bold: ['The Vivid Bloom', 'You are not afraid of colour. One confident photograph can carry the whole room.'],
    reflective: ['The Still Water', 'Moody skies, quiet water and deep tones — a place for the mind to settle at the end of the day.']
  };
  var LABEL = {};
  STEPS.forEach(function (s) { (s.opts || []).forEach(function (o) { LABEL[s.id + ':' + o[0]] = o[1]; }); });
  var FORMAT_TEXT = {
    flat: ['Flat canvas print', 'Printed to order in Martha’s studio on fine art canvas with a slim off-white border — choose the frame you love, or hang it as it is.'],
    wrap: ['Gallery-wrapped canvas', 'Stretched around a wooden frame and printed on demand — it arrives ready to hang, no framing needed.'],
    frame: ['Black framed canvas', 'Printed on demand in a black pine frame — a crisp, finished look, ready to hang.']
  };

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(u, w) { return (u.indexOf('//') === 0 ? 'https:' + u : u) + '?width=' + w; }
  function money(v) { return '$' + (Math.round(v * 100) / 100).toFixed(2).replace(/\.00$/, ''); }

  // Geometry of a product: union of the panel boxes, and the total width/height for a given panel size
  function geo(p) {
    var b = p.b && p.b.length ? p.b : [[0, 0, 1, 1]];
    var u = [1, 1, 0, 0], bw = 0, bh = 0;
    b.forEach(function (x) { u[0] = Math.min(u[0], x[0]); u[1] = Math.min(u[1], x[1]); u[2] = Math.max(u[2], x[2]); u[3] = Math.max(u[3], x[3]); bw += x[2] - x[0]; bh += x[3] - x[1]; });
    return { boxes: b, u: u, fx: (u[2] - u[0]) / (bw / b.length), fy: (u[3] - u[1]) / (bh / b.length) };
  }
  function total(p, z) { var g = p._g || (p._g = geo(p)); return { w: z[0] * g.fx, h: z[1] * g.fy }; }
  function bestSize(p, target) {
    var best = null, d = 1e9;
    p.z.forEach(function (z) { var t = total(p, z), dd = Math.abs(t.w - target); if (dd < d) { d = dd; best = z; } });
    return best || p.z[0];
  }

  function Advisor(root) {
    this.root = root;
    this.base = root.getAttribute('data-product-base') || '/products/';
    this.contact = root.getAttribute('data-contact') || '/pages/contact';
    this.cat = (window.VOG_ADVISOR_CATALOG || []).filter(function (p) { return p.z && p.z.length && p.i; });
    this.a = {}; this.step = 0;
    this.render();
  }

  Advisor.prototype.render = function () {
    var self = this, root = this.root;
    root.innerHTML = '';
    if (this.step >= STEPS.length) return this.results();
    var s = STEPS[this.step];
    var card = el('div', 'vog-adv__card');
    card.appendChild(el('div', 'vog-adv__progress', '<span style="width:' + Math.round((this.step / STEPS.length) * 100) + '%"></span>'));
    card.appendChild(el('p', 'vog-adv__count', 'Question ' + (this.step + 1) + ' of ' + STEPS.length));
    card.appendChild(el('h2', 'vog-adv__q', esc(s.q)));
    card.appendChild(el('p', 'vog-adv__hint', esc(s.hint)));
    var grid = el('div', 'vog-adv__opts' + (s.width ? ' vog-adv__opts--w' : ''));
    var opts = s.width ? WIDTHS.map(function (w) { return [w[0], w[1], w[2]]; }).concat([['unsure', 'Not sure', 'Use a typical size']]) : s.opts;
    opts.forEach(function (o) {
      var b = el('button', 'vog-adv__opt' + (String(self.a[s.id]) === String(o[0]) ? ' is-on' : ''), '<b>' + esc(o[1]) + '</b><span>' + esc(o[2]) + '</span>');
      b.type = 'button';
      b.addEventListener('click', function () { self.a[s.id] = o[0]; self.next(); });
      grid.appendChild(b);
    });
    card.appendChild(grid);
    if (s.width) {
      var cw = el('form', 'vog-adv__custom', '<label for="vog-adv-w">Or enter your own width</label><div><input id="vog-adv-w" type="number" min="12" max="240" inputmode="numeric" placeholder="e.g. 80"><span>inches</span><button type="submit" class="vog-btn vog-btn--solid">Continue</button></div>');
      cw.addEventListener('submit', function (e) {
        e.preventDefault(); e.stopPropagation();
        var v = parseFloat(cw.querySelector('input').value);
        if (!(v >= 12 && v <= 240)) { cw.querySelector('input').focus(); return; }
        self.a.width = v; self.next();
      });
      card.appendChild(cw);
    }
    var nav = el('div', 'vog-adv__nav');
    if (this.step > 0) {
      var back = el('button', 'vog-adv__back', '← Back'); back.type = 'button';
      back.addEventListener('click', function () { self.step--; self.render(); self.focus(); });
      nav.appendChild(back);
    }
    card.appendChild(nav);
    root.appendChild(card);
  };

  Advisor.prototype.next = function () { this.step++; this.render(); this.focus(); };
  Advisor.prototype.focus = function () {
    var r = this.root.getBoundingClientRect();
    if (r.top < 0 || r.top > window.innerHeight * 0.5) window.scrollTo({ top: window.scrollY + r.top - 120, behavior: 'smooth' });
  };

  Advisor.prototype.target = function () {
    var a = this.a, place = a.place || 'unsure';
    var w = typeof a.width === 'number' ? a.width : DEFAULT_W[place];
    var k = FURNITURE[place] ? 0.66 : place === 'narrow' ? 0.6 : place === 'feature' ? 0.5 : 0.6;
    return { space: w, art: Math.max(10, Math.round(w * k)), measured: typeof a.width === 'number' };
  };

  Advisor.prototype.score = function (p, T) {
    var a = this.a, s = 0, why = [];
    if (a.motif && a.motif !== 'any') { if (p.m.indexOf(a.motif) > -1) { s += 3; why.push(LABEL['motif:' + a.motif]); } else s -= 2; }
    if (a.season && a.season !== 'any') { if (p.s.indexOf(a.season) > -1) { s += 2; why.push(LABEL['season:' + a.season]); } else if (p.s.length) s -= 1; }
    if (a.palette && a.palette !== 'any') { if (p.c.indexOf(a.palette) > -1) { s += 2; why.push(LABEL['palette:' + a.palette]); } else s -= 0.5; }
    if (a.feel) { var m = (p.mo && p.mo[a.feel]) || 0; s += 3 * m; if (m >= 0.55) why.push(LABEL['feel:' + a.feel]); }
    if (a.room && p.r.indexOf(a.room) > -1) s += 0.8;
    if (a.format && a.format !== 'any') { if (p.f === a.format) s += 2.5; else s -= 4; }
    if (a.pieces === 'single') s += p.n === 1 ? 2 : -2.5;
    if (a.pieces === 'set') s += p.n > 1 ? 2 : -2.5;
    var z = bestSize(p, T.art), t = total(p, z), asp = t.w / t.h, place = a.place || 'unsure';
    if (FURNITURE[place]) s += asp >= 1.2 ? 1.5 : asp < 0.8 ? -1.2 : 0;
    if (place === 'narrow') s += asp <= 0.8 ? 2 : asp >= 1.3 ? -2 : 0;
    if (place === 'feature') s += (p.n >= 3 || p.o === 'p' || t.w >= 40) ? 1.5 : 0;
    var fit = Math.abs(t.w - T.art) / T.art;
    s += fit <= 0.15 ? 1.5 : fit <= 0.3 ? 0.5 : -1.5;
    if (fit <= 0.3) why.unshift('Fits your wall');
    return { p: p, s: s, z: z, t: t, why: why };
  };

  Advisor.prototype.pick = function (T) {
    var self = this;
    var list = this.cat.map(function (p) { return self.score(p, T); }).sort(function (x, y) { return y.s - x.s; });
    var out = [];
    function word(r) { return r.p.t.toLowerCase().replace(/^(winter|spring|summer|autumn|pink|white|red|yellow|purple|vibrant|soft)\s+/g, '').split(' ').slice(0, 2).join(' '); }
    for (var i = 0; i < list.length && out.length < 3; i++) {
      var r = list[i], dup = out.some(function (o) { return word(o) === word(r) || (o.p.i === r.p.i); });
      if (!dup) out.push(r);
    }
    return out;
  };

  Advisor.prototype.results = function () {
    var self = this, a = this.a, T = this.target(), picks = this.pick(T), root = this.root;
    var per = PERSONA[a.feel] || PERSONA.calm, top = picks[0];
    var fmt = a.format && a.format !== 'any' ? a.format : (top ? top.p.f : 'flat');
    var place = a.place || 'unsure';
    var placeTip = FURNITURE[place]
      ? 'Hang it low and close to the furniture: leave about 8–10″ between the top of the ' + (place === 'bed' ? 'headboard' : place === 'console' ? 'console or mantel' : 'sofa') + ' and the bottom of the frame, and centre it on the furniture, not the wall.'
      : place === 'narrow' ? 'Centre the photograph at eye level (about 57″ from the floor to the middle of the art). A tall, vertical piece makes a narrow wall feel taller.'
        : 'Keep the centre of the arrangement around 57″ from the floor. ' + (place === 'feature' ? 'On a large wall, a set or a panoramic piece looks intentional rather than lost.' : '');
    var cover = top ? Math.round((top.t.w / T.space) * 100) : 0;

    var wrap = el('div', 'vog-adv__result');
    var sum = el('div', 'vog-adv__summary');
    sum.innerHTML = '<p class="vog-adv__kicker">Your art personality</p><h2 class="vog-adv__persona">' + esc(per[0]) + '</h2><p class="vog-adv__mood">' + esc(per[1]) + '</p>' +
      '<dl class="vog-adv__facts">' +
      '<div><dt>Ideal art width</dt><dd>About ' + T.art + '″ wide <small>' + (T.measured ? 'for your ' + T.space + '″ ' + (FURNITURE[place] ? 'furniture' : 'wall space') : 'for a typical ' + (LABEL['place:' + place] || 'wall').toLowerCase().replace('not sure yet', 'wall') + ' — measure to fine-tune') + '</small></dd></div>' +
      (top ? '<div><dt>Your top pick</dt><dd>' + esc(top.z[0] + ' × ' + top.z[1]) + '″' + (top.p.n > 1 ? ' per print, ' + top.p.n + ' prints' : '') + ' <small>about ' + Math.round(top.t.w) + '″ wide in total · fills ' + cover + '% of the width</small></dd></div>' : '') +
      '<div><dt>Best format</dt><dd>' + esc(FORMAT_TEXT[fmt][0]) + ' <small>' + esc(FORMAT_TEXT[fmt][1]) + '</small></dd></div>' +
      '<div><dt>Placement</dt><dd><small>' + esc(placeTip) + (picks.some(function (r) { return r.p.n > 1; }) ? ' For sets, keep the same 2–3″ gap between prints.' : '') + '</small></dd></div>' +
      '</dl>';
    wrap.appendChild(sum);

    var cards = el('div', 'vog-adv__picks');
    cards.appendChild(el('p', 'vog-adv__kicker', 'Three photographs chosen for you'));
    var grid = el('div', 'vog-adv__cards');
    picks.forEach(function (r, i) {
      var p = r.p, href = self.base + p.h;
      var kick = p.k || (p.s[0] ? p.s[0].charAt(0).toUpperCase() + p.s[0].slice(1) : 'Nature') + (p.n > 1 ? ' · Set of ' + p.n : '');
      var price = (r.z[2] ? money(r.z[2]) : '');
      var c = el('article', 'vog-adv__pc');
      c.innerHTML = '<a class="vog-adv__pimg" href="' + esc(href) + '"><img src="' + esc(img(p.i, 700)) + '" alt="' + esc(p.t) + ' — nature photograph by Martha Solo" loading="lazy"></a>' +
        '<div class="vog-adv__pbody"><p class="vog-adv__pk">' + (i === 0 ? '<b>Best match</b> · ' : '') + esc(kick) + '</p><h3><a href="' + esc(href) + '">' + esc(p.t) + '</a></h3>' +
        '<p class="vog-adv__psize">' + esc(r.z[0] + ' × ' + r.z[1]) + '″' + (p.n > 1 ? ' each' : '') + (price ? ' · ' + price : '') + ' <span>' + esc(FORMAT_TEXT[p.f][0]) + '</span></p>' +
        (r.why.length ? '<ul class="vog-adv__why">' + r.why.slice(0, 4).map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('') + '</ul>' : '') +
        '<div class="vog-adv__pact"><a class="vog-adv__link" href="' + esc(href) + '">View this print →</a><button type="button" class="vog-adv__try" data-i="' + i + '">Try it on my wall</button></div></div>';
      grid.appendChild(c);
    });
    cards.appendChild(grid);
    wrap.appendChild(cards);
    root.appendChild(wrap);

    var wall = el('div', 'vog-adv__wall');
    root.appendChild(wall);
    var acts = el('div', 'vog-adv__end');
    acts.innerHTML = '<button type="button" class="vog-btn vog-btn--solid vog-adv__open">Try it on my wall</button><button type="button" class="vog-btn vog-btn--line vog-adv__again">Start again</button><a class="vog-btn vog-btn--line" href="' + esc(this.contact) + '">Ask Martha a question</a>';
    root.appendChild(acts);
    acts.querySelector('.vog-adv__again').addEventListener('click', function () { self.a = {}; self.step = 0; self.render(); self.focus(); });
    var open = function (i) { new Wall(wall, picks, i, T); wall.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
    acts.querySelector('.vog-adv__open').addEventListener('click', function () { open(0); });
    Array.prototype.forEach.call(root.querySelectorAll('.vog-adv__try'), function (b) { b.addEventListener('click', function () { open(+b.getAttribute('data-i')); }); });
    this.focus();
  };

  /* ---------- Try it on my wall ---------- */
  function Wall(host, picks, idx, T) {
    var self = this;
    this.host = host; this.picks = picks; this.T = T; this.photo = null; this.art = null;
    host.innerHTML = '<div class="vog-adv__wallhead"><div><p class="vog-adv__kicker">Try it on my wall</p><h2 class="vog-adv__q">See it in your own room</h2><p class="vog-adv__hint">Upload a photo of your wall, then drag the artwork into place and adjust the size. <b>Your photo stays on your device</b> — nothing is uploaded or saved.</p></div></div>' +
      '<div class="vog-adv__wallgrid"><div class="vog-adv__stage"><canvas width="1200" height="800" aria-label="Artwork shown on a wall"></canvas><p class="vog-adv__tip">Drag the artwork to move it.</p></div>' +
      '<div class="vog-adv__ctrl"><div class="vog-adv__thumbs" role="tablist"></div>' +
      '<label class="vog-btn vog-btn--solid vog-adv__upload">Upload a wall photo<input type="file" accept="image/*" hidden></label>' +
      '<label class="vog-adv__field">Width of the wall area in your photo<span><input type="number" class="vog-adv__ww" min="24" max="600" value="120"> inches</span><small>An estimate is fine — it keeps the artwork true to scale.</small></label>' +
      '<label class="vog-adv__field">Artwork size<input type="range" class="vog-adv__sz" min="10" max="200" value="100"><small class="vog-adv__szout"></small></label>' +
      '<div class="vog-adv__wbtns"><button type="button" class="vog-btn vog-btn--line vog-adv__reset">Reset</button><button type="button" class="vog-btn vog-btn--line vog-adv__dl">Save image</button></div></div></div>';
    this.cv = host.querySelector('canvas'); this.ctx = this.cv.getContext('2d');
    var th = host.querySelector('.vog-adv__thumbs');
    picks.forEach(function (r, i) {
      var b = el('button', 'vog-adv__th', '<img src="' + esc(img(r.p.i, 200)) + '" alt="' + esc(r.p.t) + '">'); b.type = 'button'; b.setAttribute('role', 'tab');
      b.addEventListener('click', function () { self.choose(i); });
      th.appendChild(b);
    });
    host.querySelector('input[type=file]').addEventListener('change', function (e) {
      var f = e.target.files && e.target.files[0]; if (!f) return;
      var rd = new FileReader();
      rd.onload = function () { var im = new Image(); im.onload = function () { self.photo = im; self.fit(); self.place(); }; im.src = rd.result; };
      rd.readAsDataURL(f);
    });
    host.querySelector('.vog-adv__ww').addEventListener('input', function () { self.place(); });
    host.querySelector('.vog-adv__sz').addEventListener('input', function () { self.scale = this.value / 100; self.size(); self.draw(); });
    host.querySelector('.vog-adv__reset').addEventListener('click', function () { self.place(); });
    host.querySelector('.vog-adv__dl').addEventListener('click', function () { self.save(); });
    this.drag();
    this.fit(); this.choose(idx);
  }
  Wall.prototype.fit = function () {
    var W = 1200, H = this.photo ? Math.round(W * this.photo.naturalHeight / this.photo.naturalWidth) : 760;
    this.cv.width = W; this.cv.height = Math.max(400, Math.min(1600, H));
  };
  Wall.prototype.choose = function (i) {
    var self = this, r = this.picks[i]; this.cur = r;
    Array.prototype.forEach.call(this.host.querySelectorAll('.vog-adv__th'), function (b, j) { b.classList.toggle('is-on', j === i); b.setAttribute('aria-selected', j === i); });
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = function () { self.art = im; self.place(); };
    im.src = img(r.p.i, 1400);
  };
  Wall.prototype.place = function () {
    if (!this.cur) return;
    var g = this.cur.p._g || geo(this.cur.p);
    this.ratio = this.art ? ((g.u[3] - g.u[1]) * this.art.naturalHeight) / ((g.u[2] - g.u[0]) * this.art.naturalWidth) : this.cur.t.h / this.cur.t.w;
    this.scale = 1; this.host.querySelector('.vog-adv__sz').value = 100;
    this.size();
    this.x = (this.cv.width - this.w) / 2;
    this.y = this.photo ? this.cv.height * 0.38 - this.h / 2 : this.cv.height * 0.56 - this.h - 34;
    if (this.y < 10) this.y = 10;
    this.draw();
  };
  Wall.prototype.size = function () {
    var ww = parseFloat(this.host.querySelector('.vog-adv__ww').value) || 120;
    var inches = this.cur.t.w * this.scale;
    var cx = this.w ? this.x + this.w / 2 : null, cy = this.h ? this.y + this.h / 2 : null;
    this.w = Math.min(this.cv.width * 0.98, (inches / ww) * this.cv.width);
    this.h = this.w * this.ratio;
    if (cx != null) { this.x = cx - this.w / 2; this.y = cy - this.h / 2; }
    var real = (this.w / this.cv.width) * ww;
    this.host.querySelector('.vog-adv__szout').textContent = 'About ' + Math.round(real) + '″ wide on your wall';
  };
  Wall.prototype.room = function () {
    var c = this.ctx, W = this.cv.width, H = this.cv.height, fl = H * 0.8;
    var gr = c.createLinearGradient(0, 0, 0, fl); gr.addColorStop(0, '#EFE8DC'); gr.addColorStop(1, '#E2D8C8');
    c.fillStyle = gr; c.fillRect(0, 0, W, fl);
    c.fillStyle = '#B89A78'; c.fillRect(0, fl, W, H - fl);
    c.fillStyle = 'rgba(0,0,0,.08)'; c.fillRect(0, fl, W, 6);
    // simple sofa silhouette, 84 in wide on a 120 in wall
    var sw = W * 0.7, sx = (W - sw) / 2, sy = H * 0.56;
    c.fillStyle = '#7C8466'; this.rr(sx, sy, sw, fl - sy - 16, 18); c.fill();
    c.fillStyle = '#6A7256'; this.rr(sx - 18, sy + 50, 46, fl - sy - 66, 14); c.fill(); this.rr(sx + sw - 28, sy + 50, 46, fl - sy - 66, 14); c.fill();
    c.fillStyle = '#4E4438'; c.fillRect(sx + 20, fl - 18, 10, 18); c.fillRect(sx + sw - 30, fl - 18, 10, 18);
  };
  Wall.prototype.rr = function (x, y, w, h, r) { var c = this.ctx; c.beginPath(); c.moveTo(x + r, y); c.arcTo(x + w, y, x + w, y + h, r); c.arcTo(x + w, y + h, x, y + h, r); c.arcTo(x, y + h, x, y, r); c.arcTo(x, y, x + w, y, r); c.closePath(); };
  Wall.prototype.draw = function () {
    var c = this.ctx, W = this.cv.width, H = this.cv.height;
    c.clearRect(0, 0, W, H);
    if (this.photo) c.drawImage(this.photo, 0, 0, W, H); else this.room();
    if (!this.art || !this.cur) return;
    var g = this.cur.p._g || geo(this.cur.p), A = this.art, nw = A.naturalWidth, nh = A.naturalHeight;
    var ux = g.u[0], uy = g.u[1], uw = g.u[2] - g.u[0], uh = g.u[3] - g.u[1], x0 = this.x, y0 = this.y, w = this.w, h = this.h;
    g.boxes.forEach(function (b) {
      var dx = x0 + ((b[0] - ux) / uw) * w, dy = y0 + ((b[1] - uy) / uh) * h, dw = ((b[2] - b[0]) / uw) * w, dh = ((b[3] - b[1]) / uh) * h;
      c.save(); c.shadowColor = 'rgba(0,0,0,.35)'; c.shadowBlur = Math.max(6, dw * 0.04); c.shadowOffsetY = Math.max(3, dw * 0.015);
      c.fillStyle = '#fff'; c.fillRect(dx, dy, dw, dh); c.restore();
      c.drawImage(A, b[0] * nw, b[1] * nh, (b[2] - b[0]) * nw, (b[3] - b[1]) * nh, dx, dy, dw, dh);
    });
  };
  Wall.prototype.drag = function () {
    var self = this, cv = this.cv, on = false, ox = 0, oy = 0;
    function pt(e) { var r = cv.getBoundingClientRect(); return { x: (e.clientX - r.left) * cv.width / r.width, y: (e.clientY - r.top) * cv.height / r.height }; }
    cv.addEventListener('pointerdown', function (e) {
      var p = pt(e);
      if (p.x >= self.x && p.x <= self.x + self.w && p.y >= self.y && p.y <= self.y + self.h) { on = true; ox = p.x - self.x; oy = p.y - self.y; cv.setPointerCapture(e.pointerId); cv.classList.add('is-drag'); e.preventDefault(); }
    });
    cv.addEventListener('pointermove', function (e) { if (!on) return; var p = pt(e); self.x = p.x - ox; self.y = p.y - oy; self.draw(); });
    function up() { on = false; cv.classList.remove('is-drag'); }
    cv.addEventListener('pointerup', up); cv.addEventListener('pointercancel', up);
  };
  Wall.prototype.save = function () {
    try {
      var a = document.createElement('a'); a.download = 'my-wall-' + this.cur.p.h + '.png'; a.href = this.cv.toDataURL('image/png');
      document.body.appendChild(a); a.click(); a.remove();
    } catch (err) { console.error('Art Advisor: could not save the image', err); }
  };

  // Used by the product page: open the wall tool for one product (p = catalog item, z = [width, height] in inches)
  window.VOGWall = function (host, p, z) { return new Wall(host, [{ p: p, z: z, t: total(p, z), why: [] }], 0, null); };

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vog-advisor]'), function (root) {
      if (root.__vogAdv) return; root.__vogAdv = true;
      try { new Advisor(root); } catch (err) { console.error('Art Advisor failed to start', err); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
